<script lang="ts">
	import { signIn } from '$lib/auth/client.svelte';
	import Button from '$lib/components/atoms/button/Button.svelte';
	import { i18nPath } from '$lib/i18n/routing';
	import { track } from '$lib/services/tracking/googleAnalytics';
	import * as m from '$paraglide/messages';
	import { languageTag } from '$paraglide/runtime';

	function login() {
		signIn(i18nPath('/routes/search-car', languageTag()));
	}
</script>

<div
	class="bg-primary-weakest border-1 border-solid border-neutral-soft p-4 rd-2 flex flex-col gap-2"
>
	<div>
		<div class="text-md text-bold">{m.register_car__account_title()}</div>
		<div class="text-sm">{m.register_car__account_subtitle()}</div>
	</div>
	<div class="flex gap-2">
		<Button
			text={m.action__sign_in()}
			onclick={() => {
				track({
					action: 'account_card',
					payload: {
						action: 'login',
					},
				});
				login();
			}}
		/>
		<Button
			variant="ghost"
			text={m.action__sign_up()}
			onclick={() => {
				track({
					action: 'account_card',
					payload: {
						action: 'signup',
					},
				});
				login();
			}}
		/>
	</div>
</div>
